import { formatUsd, formatUsdPerMile, type PayBreakdown } from "@haulsheet/core";

function Row({
  label,
  cents,
  emphasize,
}: {
  label: string;
  cents: number;
  emphasize?: boolean;
}) {
  return (
    <tr>
      <td style={emphasize ? { fontWeight: 700 } : undefined}>{label}</td>
      <td className="num" style={emphasize ? { fontWeight: 700 } : undefined}>
        {formatUsd(cents)}
      </td>
    </tr>
  );
}

export function PayBreakdownTable({ pay }: { pay: PayBreakdown }) {
  return (
    <div className="card" data-testid="pay-breakdown">
      <table className="table">
        <tbody>
          <Row label="Linehaul" cents={pay.linehaulCents} />
          <Row label="FSC" cents={pay.fscCents} />
          <Row label="Accessorials" cents={pay.accessorialsCents} />
          <Row label="Cut" cents={pay.cutCents} />
          <Row label="Keep" cents={pay.keepCents} emphasize />
          <Row label="Fuel" cents={pay.fuelCents} />
          <Row label="Other" cents={pay.otherCents} />
          {pay.truckPayCents > 0 ? (
            <Row label="Truck pay" cents={pay.truckPayCents} />
          ) : null}
          <Row label="Cost" cents={pay.costCents} />
          <Row label="Profit" cents={pay.profitCents} emphasize />
        </tbody>
      </table>
      {/* analyze() per-mile figures are cents per mile: format, never toFixed. */}
      <div className="muted" style={{ marginTop: "0.75rem", fontSize: "0.85rem" }} data-testid="pay-per-mile">
        {pay.keepPerLoadedMile != null ? (
          <>
            Keep <span data-testid="keep-per-loaded-mile">{formatUsdPerMile(pay.keepPerLoadedMile)}</span>/loaded mi ·{" "}
          </>
        ) : null}
        {pay.keepPerTotalMile != null ? (
          <>
            <span data-testid="keep-per-total-mile">{formatUsdPerMile(pay.keepPerTotalMile)}</span>/total mi ·{" "}
          </>
        ) : null}
        {pay.loadedMiles} loaded / {pay.totalMiles} total mi
      </div>
    </div>
  );
}
